import { defineComponent as _defineComponent } from 'vue';
import { useGetAccountQuery } from '~/types/types';
import { useAccountUsersPage } from '~/functions/account-users-page';
export default /*#__PURE__*/_defineComponent({
  __name: 'users',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      accountResult = _useGetAccountQuery.result,
      sessionAccountLoading = _useGetAccountQuery.loading;
    var sessionAccountId = computed(function () {
      var _accountResult$value, _accountResult$value$;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : (_accountResult$value$ = _accountResult$value.getAccount) === null || _accountResult$value$ === void 0 ? void 0 : _accountResult$value$.id;
    });
    var _useAccountUsersPage = useAccountUsersPage({
        accountId: sessionAccountId,
        allowIxAdmin: true
      }),
      accessLoading = _useAccountUsersPage.loading,
      canAccess = _useAccountUsersPage.canAccess,
      isIxAdminSession = _useAccountUsersPage.isIxAdminSession,
      isAccountAdmin = _useAccountUsersPage.isAccountAdmin,
      listUsersFilter = _useAccountUsersPage.listUsersFilter,
      disableReviewerRole = _useAccountUsersPage.disableReviewerRole,
      userTableColumns = _useAccountUsersPage.userTableColumns;
    var loading = computed(function () {
      return sessionAccountLoading.value || accessLoading.value;
    });
    var accountId = sessionAccountId;
    return {
      __sfc: true,
      $auth: $auth,
      accountResult: accountResult,
      sessionAccountLoading: sessionAccountLoading,
      sessionAccountId: sessionAccountId,
      accessLoading: accessLoading,
      canAccess: canAccess,
      isIxAdminSession: isIxAdminSession,
      isAccountAdmin: isAccountAdmin,
      listUsersFilter: listUsersFilter,
      disableReviewerRole: disableReviewerRole,
      userTableColumns: userTableColumns,
      loading: loading,
      accountId: accountId
    };
  }
});